import React from 'react';
import PropTypes from 'prop-types';
import {customers} from "../../ducks";
import {duckify, singleDuck, filterDuck} from "../../utils/duckify";
import Placeholder from "../Placeholder";
import registeredComponent from '../../utils/registeredComponent';
import UploadedItem from './UploadedItem'
import {entity as uploadFields} from '../../ducks/uploadFields';
import Dropzone from 'react-dropzone';
import ValidationErrors from "../forms/ValidationErrors";

class UploadFieldList extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    checklist_answer_id: PropTypes.string.isRequired,
    form_id: PropTypes.string.isRequired,
    field_name: PropTypes.string.isRequired,
  };

  static defaultProps = {
    disabled: false,
    items: []
  };

  constructor(){
    super();
    this.state = { items: [], createErrors: null, }
  }

  handleError(error) {
    this.setState({
      createErrors: error.errors,
      submitting: false,
    });

  }

  onDrop(data) {
    const {items, checklist_answer_id, form_id, field_name} = this.props;

    if (data.length > 0) {
      this.props.createNewUpload({
        file: data[0],
        checklist_answer_id: checklist_answer_id,
        form_id: form_id,
        field_name: field_name,
        items: items
      }).then(this.handleError.bind(this));
    }
  }

  render(){
    const {items, disabled, allDucksReady, max_size} = this.props;
    const {createErrors} = this.state;

    return <div>
      {createErrors && (
        <ValidationErrors
          errors={{ errors: createErrors }}
          fieldNames={{}}
          format={(_name, message) => message}
        />
      )}
      <div className="sa-form-field-group">
        <div className="sa-form-field-group-body">
          <Placeholder.loading ready={allDucksReady} content={() => <div className="upload-field-item-list">
            {items.map((item) => <UploadedItem item={item} key={item.id}/>)}
            <Dropzone className={`bulk-file-upload-dropzone pending`}
                      onDrop={this.onDrop.bind(this)}
                      disabled={disabled}
                      disableClick={disabled}
                      multiple={false}>
              <button type="button" className={"btn btn-primary btn-sm upload-field-upload-button".concat(disabled ? ' disabled' : '')}>Upload</button>
              <span className="upload-details helper-text">(Max size: {max_size} MB)</span>
            </Dropzone>
          </div>}/>
        </div>
      </div>
    </div>;
  }
}

function mapDucksToProps(ownProps){
  const {checklist_answer_id, form_id, field_name} = ownProps;
  return {
    customer: singleDuck(customers, 'current'),
    items: filterDuck(uploadFields, {
      checklist_answer_id: checklist_answer_id,
      form_id: form_id,
      field_name: field_name
    }, field_name)
  };
}

function mapStateToProps(state, ownProps){
  return {
    createErrors: state.createErrors
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  createNewUpload: (data) => dispatch(uploadFields.actions.dirtyCreate(data))
});

export default registeredComponent("UploadFieldList")(duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(UploadFieldList));
